import { IContact } from '@blcloud/bl-datamodel';
import { ContactDateSearchDiv } from '@blcloud/bl-datamodel/enum/deals/contact-date-search-div';
import { ContactExtractTargetMPExistDiv } from '@blcloud/bl-datamodel/enum/deals/contact-extract-target-m-p-exist-div';
import {
  ContactExtractTargetEntrustedContractExistDiv,
} from '@blcloud/bl-datamodel/enum/lease/contact-extract-target-entrusted-contract-exist-div';
import { BlApiErrorInfo } from '@blcloud/bl-ng-common';
import { ICheckboxCellParameter } from '@blcloud/bl-ng-ui-component';

// -----------------------------------------------------------------------------------------
// interface
// -----------------------------------------------------------------------------------------
/**
 * グリッド表示用コンタクト情報
 */
export interface IContactForGrid {
  /** 仮ID */
  tempId: number;

  /** チェックパラメータ */
  checkParam?: ICheckboxCellParameter;

  /** コンタクト情報（グリッド表示用整形前） */
  contact?: IContact;

  /** 更新状況 */
  updateStatus?: string;

  /** 再連絡フラグ / 再（再コンタクト） */
  reContactFlag?: boolean;

  /** 済（コンタクト実施済・未実施） */
  implementedFlag?: boolean;

  /** コンタクト状況 */
  status?: ContactStatus;

  /** サービスカラー / 商品サービスカラー */
  itemServiceColor?: string;

  /** 実施予定日 */
  scheduleDate?: string;

  /** 実施予定時刻 / 時間（実施予定時間） */
  scheduleTime?: string;

  /** 連絡可能時間帯 */
  contactEnableTimeName?: string;

  /** 実施内容 */
  executeItem?: string; //

  /** 実施手段 */
  contactMethodName?: string;

  /** コンタクト区分名称 */
  contactItemName?: string;

  /** 基準日 */
  contactStandartDate?: string;

  /** 実施担当 */
  contactEmployeeName?: string;

  /** 顧客名 */
  customerName?: string;

  /** 顧客名カナ */
  customerNameKana?: string;

  /** 顧客担当名称 */
  managerName?: string;

  /** 連絡先 */
  contactInformation?: string;

  /** 連絡種別コード */
  contactTypeCode?: number;

  /** 車種 */
  vehicleModelFullWName?: string;

  /** 登録番号 */
  displayNumPlate?: string;

  /** 車両ラベル */
  vehicleLabelName?: string;

  /** 拠点 */
  baseName?: string;

  /** ランク名称 */
  customerRankName?: string;

  /** ラベル */
  customerLabel?: string;

  /** 結果区分 */
  executeResultDivName?: string;

  /** 実施結果 */
  executeResult?: string;

  /** 実施日 */
  implementDate?: string;

  /** 実施時刻 / 時間（実施時間） */
  implementTime?: string;

  /** 失注理由 */
  lostReason?: string;

  /** メモ */
  contactComment?: string;

  /** 顧客コード */
  customerCode?: number;

  /** 車両管理番号 */
  vehicleMgtNumber?: number;

  /** 受付キー表示用文字列 */
  receptionKeyStr?: string;

  /** 個人・法人区分のEnum名称 */
  privCorpDivEnumName?: string;

  /** 自動車の追加情報1 */
  vcleAddInfo1?: string;

  /** 自動車の追加情報2 */
  vcleAddInfo2?: string;

  /** 自動車の追加情報3 */
  vcleAddInfo3?: string;

  /** 初年度登録年月 */
  firstRegistYearMonth?: string;

  /** 車検証備考(メモ) */
  vcleInspCertifRemarksMemo?: string;

  /** 受託リース契約終了年月（表示用） */
  entrustedContractTermEndYearMonth?: string;

  /** 車検満期日（表示用） */
  vcleInspDueDate?: string;

  /** 顧客車両備考内容1 */
  customerVehicleRemarksContent1?: string;

  /** 顧客車両備考内容2 */
  customerVehicleRemarksContent2?: string;

  /** 顧客車両備考内容3 */
  customerVehicleRemarksContent3?: string;

  /** 顧客車両備考内容4 */
  customerVehicleRemarksContent4?: string;

  /** 顧客車両備考内容5 */
  customerVehicleRemarksContent5?: string;

  /** 顧客車両備考内容6 */
  customerVehicleRemarksContent6?: string;

  /** 顧客車両備考内容7 */
  customerVehicleRemarksContent7?: string;

  /** 顧客車両備考内容8 */
  customerVehicleRemarksContent8?: string;

  /** 顧客車両備考内容9 */
  customerVehicleRemarksContent9?: string;

  /** 顧客車両備考内容10 */
  customerVehicleRemarksContent10?: string;
}

/**
 * 拡張コンタクト情報
 */
export interface IContactEx extends IContact {
  /** グリッド表示用コンタクト情報 */
  gridData: IContactForGrid;
}

/**
 * BL API のエラーにコンタクト一覧抽出進捗区分（contactListExtractProgressDiv）を付けた型。
 * 進捗由来の一覧抽出失敗で CountOverError を識別し、画面上でワーニング可否を決めるために用います。
 */
export type BlApiErrorInfoWithContactListExtractDiv = BlApiErrorInfo & {
  contactListExtractProgressDiv?: string | null;
};

// -----------------------------------------------------------------------------------------
// enum
// -----------------------------------------------------------------------------------------
/**
 * 期間区分
 */
export const PeriodDiv = {
  /** 先月 */
  LastMonth: '0',
  /** 先週 */
  LastWeek: '1',
  /** 昨日 */
  Yesterday: '2',
  /** 今日 */
  Today: '3',
  /** 明日 */
  Tomorrow: '4',
  /** 今週 */
  ThisWeek: '5',
  /** 来週 */
  NextWeek: '6',
  /** 今月 */
  ThisMonth: '7',
  /** 来月 */
  NextMonth: '8'
};

/**
 * 期間区分の配列情報
 */
export const PeriodDivArray: Array<{ value: string, text: string }> = [
  { value: PeriodDiv.LastMonth, text: '先月' },
  { value: PeriodDiv.LastWeek, text: '先週' },
  { value: PeriodDiv.Yesterday, text: '昨日' },
  { value: PeriodDiv.Today, text: '今日' },
  { value: PeriodDiv.Tomorrow, text: '明日' },
  { value: PeriodDiv.ThisWeek, text: '今週' },
  { value: PeriodDiv.NextWeek, text: '来週' },
  { value: PeriodDiv.ThisMonth, text: '今月' },
  { value: PeriodDiv.NextMonth, text: '来月' }
];

/**
 * コンタクト状況
 */
export enum ContactStatus {
  /** なし */
  None = '',
  /** 作業中 */
  Working = '作業中',
  /** 済 */
  Already = '済'
}

// -----------------------------------------------------------------------------------------
// const
// -----------------------------------------------------------------------------------------
/**
 * 実施内容グループ区分
 */
export const EXECUTE_CHECK_GROUP_DIV: { [key: string]: number } = {
  /** 車検 */
  VEHICLE_INSPECTION: 1,

  /** 点検 */
  INSPECTION: 2,

  /** その他 */
  OTHER: 3
};

/**
 * 受託リース契約有無区分(検索用)
 */
export const ENTRUSTED_CONTRACT_EXIST_DIV_SEARCH: { [key: string]: string } = {
  /** 未選択 */
  NONE: '0',
  /** リース契約のみ */
  LEASE_ONLY: '1',
  /** リース契約以外 */
  BASIC_ONLY: '2',
  /** どちらも */
  ALL: '3'
};

/**
 * 実施内容グループリスト
 */
export const EXECUTE_CHECK_GROUP_LIST: { name: string, code: number }[] = [
  { code: EXECUTE_CHECK_GROUP_DIV.VEHICLE_INSPECTION, name: '車検' },
  { code: EXECUTE_CHECK_GROUP_DIV.INSPECTION, name: '点検' },
  { code: EXECUTE_CHECK_GROUP_DIV.OTHER, name: 'その他' }
];

/**
 * コンタクト日付検索区分リスト
 */
export const CONTACT_DATE_SEARCH_DIV_LIST: { name: string, code: string }[] = [
  { code: ContactDateSearchDiv.ContactScheduleDateTime, name: '実施予定日' },
  { code: ContactDateSearchDiv.ContactDateTime, name: '実施日' },
  { code: ContactDateSearchDiv.ContactStandartDate, name: '実施基準日' }
];

/**
 * コンタクト抽出対象MP有無区分リスト
 */
export const CONTACT_EXTRACT_TARGET_MP_EXIST_DIV_LIST: { name: string, code: string }[] = [
  { code: ContactExtractTargetMPExistDiv.MaintePackOnly, name: 'MPのみ' },
  { code: ContactExtractTargetMPExistDiv.BasicOnly, name: 'MP以外' },
  { code: ContactExtractTargetMPExistDiv.All, name: 'どちらも' }
];

/**
 * 受託リース契約有無区分(検索用)リスト
 */
export const ENTRUSTED_CONTRACT_EXIST_DIV_SEARCH_LIST: { name: string, code: string }[] = [
  { code: ENTRUSTED_CONTRACT_EXIST_DIV_SEARCH.LEASE_ONLY, name: 'リース契約のみ' },
  { code: ENTRUSTED_CONTRACT_EXIST_DIV_SEARCH.BASIC_ONLY, name: 'リース契約以外' },
  { code: ENTRUSTED_CONTRACT_EXIST_DIV_SEARCH.ALL, name: 'どちらも' }
] ;

/**
 * コンタクト抽出対象リース受託契約有無区分リスト
 */
export const CONTACT_EXTRACT_TARGET_ENTRUSTED_CONTRACT_EXIST_DIV_LIST: { name: string, code: string }[] = [
  { code: ContactExtractTargetEntrustedContractExistDiv.LeaseOnly, name: 'リース契約のみ' },
  { code: ContactExtractTargetEntrustedContractExistDiv.BasicOnly, name: 'リース契約以外' },
  { code: ContactExtractTargetEntrustedContractExistDiv.All, name: 'どちらも' },
];

/**
 * 自動生成履歴用の実施内容コードリスト
 */
export const AUTO_GENERATION_HISTORY_EXECUTE_ITEM_CODE_LIST = [90018, 90019, 90020, 90021, 90022, 90023, 90024];

/**
 * 除外コンタクト手段コード
 */
export const CONTACT_METHOD_CODE_IGNORE = 999999999;

/**
 * イベントID
 */
export const EVENT_ID = {
  /** 車両販売 */
  CAR_SALES: '8',

  /** タスク */
  TASK: '1001'
};

/**
 * リース関連コンタクト抽出項目コード
 * ※受託リース車両管理サービスが無効の場合に除外するコード
 */
export const LEASE_CONTACT_EXECUTE_ITEM_CODE = {
  /** リース定期6ヶ月点検 */
  LEASE_PERIODIC_6MONTH_INSPECTION: 90070,
  /** スケジュール点検(1ヶ月) */
  SCHEDULE_INSPECTION_1MONTH: 90081,
  /** スケジュール点検(2ヶ月) */
  SCHEDULE_INSPECTION_2MONTH: 90082,
  /** スケジュール点検(3ヶ月) */
  SCHEDULE_INSPECTION_3MONTH: 90083,
  /** スケジュール点検(4ヶ月) */
  SCHEDULE_INSPECTION_4MONTH: 90084,
  /** スケジュール点検(6ヶ月) */
  SCHEDULE_INSPECTION_6MONTH: 90086,
  /** スケジュール点検(12ヶ月) */
  SCHEDULE_INSPECTION_12MONTH: 90092,
};

/**
 * リース関連コンタクト抽出項目コードリスト
 * ※受託リース車両管理サービスが無効の場合に除外するコードリスト
 */
export const LEASE_CONTACT_EXECUTE_ITEM_CODE_LIST: number[] = [
  LEASE_CONTACT_EXECUTE_ITEM_CODE.LEASE_PERIODIC_6MONTH_INSPECTION,
  LEASE_CONTACT_EXECUTE_ITEM_CODE.SCHEDULE_INSPECTION_1MONTH,
  LEASE_CONTACT_EXECUTE_ITEM_CODE.SCHEDULE_INSPECTION_2MONTH,
  LEASE_CONTACT_EXECUTE_ITEM_CODE.SCHEDULE_INSPECTION_3MONTH,
  LEASE_CONTACT_EXECUTE_ITEM_CODE.SCHEDULE_INSPECTION_4MONTH,
  LEASE_CONTACT_EXECUTE_ITEM_CODE.SCHEDULE_INSPECTION_6MONTH,
  LEASE_CONTACT_EXECUTE_ITEM_CODE.SCHEDULE_INSPECTION_12MONTH,
];



// WEBPACK FOOTER //
// ./src/app/shared/contact/contact-page.interface.ts